// pipe: frontend wave F5 — Sales sidebar entry (links to the leads funnel; the in-family nav
// reaches quotes/pipeline/campaigns/activities). Cloned from records-button.tsx / work-button.tsx
// (verbatim shape) — only the route, the active-path prefix, the icon, the label key, and the
// testid differ. NOT admin-gated: these are ops screens for Erp staff — the server 403s
// unauthorized reads and the screens render the localized load-error state.
import { useI18n } from '@affine/i18n';
import { ContactWithUsIcon } from '@blocksuite/icons/rc';
import { useServices } from '@toeverything/infra';

import { MenuLinkItem } from '../../modules/app-sidebar/views';
import { WorkbenchService } from '../../modules/workbench';
import { useNavPrefixActive } from './use-nav-prefix-active';

export const SalesButton = () => {
  const t = useI18n();
  const { workbenchService } = useServices({ WorkbenchService });
  const workbench = workbenchService.workbench;
  // REACTIVE active state: any /sales/* route keeps the entry lit.
  const active = useNavPrefixActive(workbench, '/sales');

  return (
    <MenuLinkItem
      icon={<ContactWithUsIcon />}
      active={active}
      to={'/sales/leads'}
    >
      <span data-testid="pipe-sales-nav">
        {t['com.affine.pipe.sales.nav']()}
      </span>
    </MenuLinkItem>
  );
};
